import Vue from 'vue';

Vue.filter('concatName2', function (obj) {
  if (obj) {
    return obj.first_name + ' ' + obj.last_name;
  }
})
